import service from './service';

export default {
  /**
   * 获取广告列表
   * @param []string ids 逗号隔开的广告类型 e.g 1,2,3
   */
  getAdvertise(ids) {
    return service.get(`/api/v1/ads/pc/${ids}`);
  }
};



// WEBPACK FOOTER //
// ./src/api/advertise.js